export default "__VITE_ASSET__BEXDU4n0__"